import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaExclamationTriangle, FaTimes, FaArrowRight } from 'react-icons/fa';
import { useTheme } from '../../contexts/ThemeContext.jsx';
import { useAbonnement } from '../../hooks/useAbonnement';

const CLE_MASQUAGE = 'secura:bandeau-essai-masque';

/**
 * Bandeau affiché quand la période d'essai se termine dans la semaine.
 * Masquable pour la session en cours : le but est de prévenir, pas de harceler.
 */
const SubscriptionBanner = () => {
  const { isDark } = useTheme();
  const navigate = useNavigate();
  const { bientotExpire, joursRestants, dateExpiration } = useAbonnement();
  const [masque, setMasque] = useState(() => {
    try {
      return sessionStorage.getItem(CLE_MASQUAGE) === '1';
    } catch {
      return false;
    }
  });

  if (!bientotExpire || masque) return null;

  const masquer = () => {
    setMasque(true);
    try {
      sessionStorage.setItem(CLE_MASQUAGE, '1');
    } catch {
      // stockage indisponible (navigation privée) : le bandeau reviendra, sans gravité
    }
  };

  const echeance = dateExpiration
    ? new Date(dateExpiration).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })
    : null;
  const delai = joursRestants <= 0
    ? "se termine aujourd'hui"
    : `se termine dans ${joursRestants} jour${joursRestants > 1 ? 's' : ''}`;

  return (
    <div
      role="status"
      className={`flex flex-wrap items-center gap-3 px-4 py-3 border-b ${
        isDark ? 'bg-amber-900/30 border-amber-800 text-amber-100' : 'bg-amber-50 border-amber-200 text-amber-900'
      }`}
    >
      <FaExclamationTriangle className={`w-5 h-5 shrink-0 ${isDark ? 'text-amber-400' : 'text-amber-500'}`} />

      <p className="text-sm flex-1 min-w-[12rem]">
        <span className="font-semibold">Votre période d&apos;essai {delai}.</span>
        {echeance ? ` Échéance le ${echeance}.` : ''} Passé ce délai, l&apos;accès aux données de votre
        entreprise sera suspendu jusqu&apos;au règlement.
      </p>

      <button
        type="button"
        onClick={() => navigate('/mon-abonnement')}
        className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
          isDark ? 'bg-amber-500 text-gray-900 hover:bg-amber-400' : 'bg-amber-600 text-white hover:bg-amber-700'
        }`}
      >
        Voir mon abonnement
        <FaArrowRight className="w-3 h-3" />
      </button>

      <button
        type="button"
        onClick={masquer}
        aria-label="Masquer ce message"
        title="Masquer ce message"
        className={`p-2 rounded-lg transition-colors ${
          isDark ? 'text-amber-300 hover:bg-amber-800/50' : 'text-amber-700 hover:bg-amber-100'
        }`}
      >
        <FaTimes className="w-4 h-4" />
      </button>
    </div>
  );
};

export default SubscriptionBanner;
